export default "__VITE_ASSET__DSVsjQdv__"